import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { spaceOptions } from './utils';

export const HeroInput = styled.input`
  font-size: 16px;
  background-color: #fff;
  border: 0;
  border-radius: 4px;
  padding: 11px 20px;
  apperance: none;
  outline: 0;
  font-family: 'Source Sans Pro';
  ${spaceOptions};
`;

export const StyledInput = styled.input`
  font-size: 16px;
  border: 0;
  border-radius: 4px;
  margin: 0 10px;
  appearance: none;
  outline: 0;
  border: 1px solid #eee;
  position: relative;
  padding: 11px 20px;

  ${props =>
    props.iconRight &&
    css`
      padding: 11px 30px 11px 11px;
    `} ${props =>
      props.iconLeft &&
      css`
        padding: 11px 11px 11px 30px;
      `} ${props =>
      props.block &&
      css`
        width: 100%;
        margin: 0;
      `} ${props =>
      props.width &&
      css`
        width: ${props.width}px;
      `} ${props =>
      props.error &&
      css`
        background-color: ${props.theme.dangerBackground};
      `} ${props =>
      props['xs-block'] &&
      css`
        width: 100%;
        margin: 0;
        margin-bottom: 10px;
        @media (min-width: 30rem) {
          width: ${`${props.width}px` || 'auto'};
          margin: 0 10px;
        }
      `};

  ${spaceOptions};
`;

const IMPERATIVE_API = [
  'blur',
  'checkValidity',
  'click',
  'focus',
  'select',
  'setCustomValidity',
  'setSelectionRange',
  'setRangeText'
];

export class Input extends Component {
  exposeAPI = el => {
    this.input = el;
    IMPERATIVE_API.forEach(ev => (this[ev] = el && el[ev] && el[ev].bind(el)));
  };

  render = () => {
    return <StyledInput {...this.props} innerRef={this.exposeAPI} />;
  };
}

const IconWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  position: relative;
  ${spaceOptions} &:after {
    vertical-align: middle;
    position: absolute;
    cursor: pointer;
    width: 35px;
    text-align: center;

    ${props =>
      props.iconRight &&
      css`
        right: 10px;
      `} ${props =>
        props.iconLeft &&
        css`
          left: 10px;
        `} ${props =>
        props.icon &&
        css`
      font-family: ${props => props.font || props.theme.fontIcons};
      content: "${props => props.icon}";
      color: ${props => props.color || props.theme.muted};
    `} ${props =>
        props.iconPath &&
        css`
          content: url(${props => props.iconPath});
        `};
  }
  ${props =>
    props.block &&
    css`
      width: 100%;
      margin: 0;
    `} ${props =>
      props['xs-block'] &&
      css`
        display: flex;
        width: 100%;
        margin: 0;
        @media (min-width(30rem)) {
          width: initial;
        }
      `};
`;
export const IconInput = ({ icon, hasError, ...props }) => (
  <IconWrapper icon={icon} {...props}>
    {' '}
    <Input error={hasError} {...props} />
  </IconWrapper>
);

IconInput.propTypes = {
  icon: PropTypes.string,
  hasError: PropTypes.bool
};

export const InputGroup = styled.div`
  display: inline-block;
  & {
    ${StyledInput} {
      border-radius: 0;
      margin-left: -1px;
      margin-right: 0;

      &:first-of-type {
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
      }

      &:last-of-type {
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
      }
    }
  }
  ${spaceOptions};
`;

export const TextArea = styled.textarea`
  font-size: 16px;
  border: 0;
  border-radius: 4px;
  width: 100%;
  appearance: none;
  outline: 0;
  border: 1px solid #eee;
  padding: 11px 20px;
  ${spaceOptions};
`;
